import React from "react";
import Page from "components/Page";
import {Card, Col, Row, } from "react-bootstrap";

import { i18n } from 'translate/i18n'
import {Link} from "react-router-dom";

const Error = () => {
    return (
        <Page>
            <h3><i className="bi bi bi-window-x text-danger"/> 404 </h3>
            <Card className="mt-3">
                <Card.Body>
                    <Row>
                        <Col className="text-center">
                            <h1 className="error-404 text-muted"> 404 </h1>
                            <h4>Oops! {i18n.t('error.error404')}</h4>
                            <Link to="/" className="btn btn-outline-primary mt-3">
                                {i18n.t('titlePage.dashboard')}
                            </Link>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Page>
    );
}

export default Error
